import { useReadContract } from "wagmi";
import { CONFIG } from "../config";
import type { Collection } from "../types";
import { publicClient } from "../lib/viem";
import { useEffect, useState } from "react";

// ABI for the getPools function
const stakingPoolsAbi = [
  {
    type: "function",
    name: "getPools",
    stateMutability: "view",
    inputs: [],
    outputs: [
      { type: "uint256[]", name: "poolIds" },
      { type: "address[]", name: "stakingTokens" },
      { type: "uint256[]", name: "durations" },
      { type: "uint256[]", name: "rewards" },
    ],
  },
] as const;

const COLLECTION_NAMES = [
  "Frostbyte", // Combined name for pools 1-3
  "MONKEES",
  "RILLAZ",
  "TokenGators",
  "GobsOnApe",
  "Dengs",
  "The Mich Khan",
  "Gs on Ape"
];

const COLLECTION_IMAGES = [
  "https://img-cdn.magiceden.dev/autoquality:size:1024000:20:80/rs:fill:800:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fapechain%2F7%252FrdF%252Fe%252F0iXY8HduhRCoIehkmFeXPeOQQFbbmIPfjCZldR2Do9LBMsNX9wNiMgCv0Q7CCvgqQoIgvdaWFzwMREE6i9rTBTuUs55QTCxO0mKp8t7jaN4Cd9xXwCCOme50UbI2OtMQhCJAWRxPG88k%252Bw%253D%253D.gif",
  "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fapechain%2Fi9YO%252F4yHXUdJsWcTqhqvf5oZLZVUq5xeS6gXFvUDeu05bnJVJsqKjrhD88RRU7ZjyIiBJg1JKFxAupZ3B0vn6pvNEt2KldEcoTcw9aQHHGTlKAMwoXzYzgDWs06TmBg5",
  "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fapechain%2FM%252FK47YBCAs6ieLgkYDuIwv46DpQnevL2hmBULPkK3BtqIGsEAhHajfy53j%252BEJA57VIHHDJctyD%252BZhyq1y%252FI7V8M2%252FnLqQGvqA%252FpHF9nImf3Hj9D%252BWmudFdLNa7CuzZTt9xZN9rRqybNkL%252FKQSfKua7hjQFizXvA2mG%252BkiZ9gxri%252F%252FcyD%252BtjMRz202ruEBjxe7%252BCraYthpbYUeNVr0kOFlAS1ppY91hfJTUBnN9Dc%252Fw2Om%252FcwPI0oIQIX%252BWvW9%252FSG4whJCzuvZuqjjYMpbyjFsLQMvWzRUsRe7%252FitSQK8zkapoGWCoaj0IZ9aYCsAAKPlCPSKGmFBRellPlVdeq3w9IydqqV2681LNqGxRb1s0bOzGaPjBSCaRDlgtf1e5yVkwWTfn1DsHY8G%252Fu3ohqWmGg%253D%253D",
  "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fapechain%2Fz9JRSpLYGu7%252BCZoKWtAuAIYpev452AQgX6bsora2mDdy4rWk9IqRe%252FkZQGmfDsTZU5TNTjJ2JfrGV2f4K9IJ0CAY%252FR587vOufEIauVjU1EQbi48ttLPRuky5gp0wy48zeXLD%252FdFXwgwIdU9SeQPuXw%253D%253D",
  "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExdW9pMTNkNndzOGRocGJ2NTNpcnpscDZnenRtMG1nYWV4dWd3ZXA2NCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/6wuw9uQfxzun7NfHbU/giphy.gif",
  "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExdGxwejg2czhzbDh5eDJ4bzhsMGowOXRjejliODVnb3Vmcnh6ZGl5ciZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/NswTQ4hxbyYnztGoJF/giphy.gif",
  "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fapechain%2Fhc%252BnPcLmWxs%252FDW99DlBQ42k40ZoyYV5jCIms5qHjwvtuWzZFhayu%252BPyZKPYgmVeetBOsk9AwbvfjdXroUmqF1HlzAqSlJVjuKQ%252BonsTdUs%252F9xw1v7HGXhzs8HF0QXL%252Bq2UcAI4sUYajgyuyrlcbU8JL6PYnlUwGyB7Uj%252FBxu2t3zq50DdknG90%252BHcusjnATbTe9lHnhFgrwsnL9uV%252F49FQ%253D%253D",
  "https://img-cdn.magiceden.dev/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fapechain%2FajjEJwOmVw1KWK2WSUR6lYj2SmnLfs8Sc2mF5pOnfO8uAuubZUK2gjjAlH32XWFd6wwPbQwLENuCbWcMahnvUc%252FWHLj2DsG5gDoeiaYvH5Ws2PUhfJ3oxywT8tCdZ5tYX%252ByqQ8pDhYEYB3n3LZ0oSg%253D%253D"
];

export function useCollections() {
  const { data: wagmiPoolsData, isLoading: isWagmiLoading } = useReadContract({
    address: CONFIG.STAKING_CONTRACT as `0x${string}`,
    abi: stakingPoolsAbi,
    functionName: "getPools",
  });

  const [poolsData, setPoolsData] = useState<Collection[] | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function fetchData() {
      try {
        if (!wagmiPoolsData) {
          const data = await publicClient.readContract({
            address: CONFIG.STAKING_CONTRACT as `0x${string}`,
            abi: stakingPoolsAbi,
            functionName: "getPools",
          });

          if (data) {
            const [poolIds, stakingTokens, durations, rewards] = data as any;
            
            // Combine first three pools into one
            const collections: Collection[] = [];
            
            // Add combined Frostbyte Mines pool
            collections.push({
              name: "Frostbyte",
              address: stakingTokens[0], // Use first pool's address
              duration: Number(durations[0]), // Use first pool's duration as default
              reward: rewards[0].toString(), // Use first pool's reward as default
              poolId: poolIds[0].toString(), // Use first pool's ID as default
              image: COLLECTION_IMAGES[0],
              verified: true,
              pools: [
                {
                  duration: 10,
                  reward: rewards[0].toString(),
                  poolId: poolIds[0].toString(),
                  name: "10 Days"
                },
                {
                  duration: 30,
                  reward: rewards[1].toString(),
                  poolId: poolIds[1].toString(),
                  name: "30 Days"
                },
                {
                  duration: 90,
                  reward: rewards[2].toString(),
                  poolId: poolIds[2].toString(),
                  name: "90 Days"
                }
              ]
            });

            // Add remaining pools
            for (let i = 3; i < stakingTokens.length; i++) {
              collections.push({
                name: COLLECTION_NAMES[i - 2] || `Pool #${i + 1}`,
                address: stakingTokens[i],
                duration: Number(durations[i]),
                reward: rewards[i].toString(),
                poolId: poolIds[i].toString(),
                image: COLLECTION_IMAGES[i - 2] || `https://placehold.co/400x400?text=Pool%20${i + 1}`,
                verified: true
              });
            }

            setPoolsData(collections);
          }
        }
      } catch (err) {
        console.error("Error fetching collections:", err);
        setError(err as Error);
      } finally {
        setIsLoading(false);
      }
    }

    if (!wagmiPoolsData && !isWagmiLoading) {
      fetchData();
    } else if (wagmiPoolsData) {
      const [poolIds, stakingTokens, durations, rewards] = wagmiPoolsData;
      
      // Combine first three pools into one
      const collections: Collection[] = [];
      
      // Add combined Frostbyte Mines pool
      collections.push({
        name: "Frostbyte",
        address: stakingTokens[0], // Use first pool's address
        duration: Number(durations[0]), // Use first pool's duration as default
        reward: rewards[0].toString(), // Use first pool's reward as default
        poolId: poolIds[0].toString(), // Use first pool's ID as default
        image: COLLECTION_IMAGES[0],
        verified: true,
        pools: [
          {
            duration: 10,
            reward: rewards[0].toString(),
            poolId: poolIds[0].toString(),
            name: "10 Days"
          },
          {
            duration: 30,
            reward: rewards[1].toString(),
            poolId: poolIds[1].toString(),
            name: "30 Days"
          },
          {
            duration: 90,
            reward: rewards[2].toString(),
            poolId: poolIds[2].toString(),
            name: "90 Days"
          }
        ]
      });

      // Add remaining pools
      for (let i = 3; i < stakingTokens.length; i++) {
        collections.push({
          name: COLLECTION_NAMES[i - 2] || `Pool #${i + 1}`,
          address: stakingTokens[i],
          duration: Number(durations[i]),
          reward: rewards[i].toString(),
          poolId: poolIds[i].toString(),
          image: COLLECTION_IMAGES[i - 2] || `https://placehold.co/400x400?text=Pool%20${i + 1}`,
          verified: true
        });
      }

      setPoolsData(collections);
      setIsLoading(false);
    }
  }, [wagmiPoolsData, isWagmiLoading]);

  return {
    data: poolsData,
    isLoading: isLoading || isWagmiLoading,
    error,
  };
}